(function(){

	// Library depencencies
	var Application = include('springroll.Application'),
		Display = include('springroll.easeljs.EaselJSDisplay');

	var cm = include('cm');

	// Define playSound for the lipsync animation exports.
	window.playSound = function(soundAlias)
	{
		// annoyingly, animate exports all playSound calls with 'wav' at the end of the argument string..
		soundAlias = soundAlias.replace(/wav$/g, '');
		cm.app.voPlayer.play(soundAlias);
	};


	window.addEventListener('unload', function(e) {
		if (cm.ViewControl.current && cm.ViewControl.current.onQuitGame) 
		{
			cm.ViewControl.current.onQuitGame();
		}
	});

	// Create a new application
	var app = new Application({
		name: "smw_dressup_time",
		canvasId: "stage",
		display: Display,
		configPath: 'assets/config/config.json',
		captionsPath: 'assets/config/captions.json',
		captions: 'captions',
		resizeElement : window,
		maxWidth : 1320,
		maxHeight : 768,
		displayOptions:	{
			clearView: true,
		}
	});
	cm.app = app;

	// Handle when app is ready to use
	app.on('init', function()
	{
		cm.analytics.launchEvent();

		// Start application
		this.game = new cm.DressupGame();
		var s = this.display.stage.canvas;

		// force the resize event
		app.triggerResize();
	});

	app.on('resize', function(w, h) {
		console.log('oh resize');
		if (this.game) {
			this.game.resize(w, h);
		}
	});


	app.on('update', function(delta) {
		if (this.game) {
			this.game.update(delta);
		}
	});

	
	
}());